import type {
  VerifyEmailConfirmDto,
  VerifyEmailConfirmResponseDto,
  VerifyEmailSendResponseDto,
} from '@nomiss/sdk';
import {
  ApiRequestError,
  executeSdkRawRequest,
} from './api-request.util';
import { authenticationApi } from './sdk-client';

export class VerifyEmailError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'VerifyEmailError');
  }
}

export async function sendVerifyEmailOtp(): Promise<VerifyEmailSendResponseDto> {
  return executeSdkRawRequest<VerifyEmailSendResponseDto>({
    request: () => authenticationApi.authControllerSendVerifyEmailV1Raw(),
    fallback: 'Failed to send verification email',
    ErrorClass: VerifyEmailError,
  });
}

export async function confirmVerifyEmailOtp(
  payload: VerifyEmailConfirmDto,
): Promise<VerifyEmailConfirmResponseDto> {
  return executeSdkRawRequest<VerifyEmailConfirmResponseDto>({
    request: () =>
      authenticationApi.authControllerConfirmVerifyEmailV1Raw({
        verifyEmailConfirmDto: payload,
      }),
    fallback: 'Email verification failed',
    ErrorClass: VerifyEmailError,
  });
}
